import { Component, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { ITileViewSelection, IVirtualGridTile } from '@shared/interfaces/virtual-grid-tile';
import {
  IListEditorTemplateComponent
} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/IListEditorTemplateComponent';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { CommandService } from '@core/services/command.service';
import { PlatformCommand, PlatformCommandResponse } from '@shared/commands/command-base';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import {ActivatedRoute, Router} from '@angular/router';
import { IPlatformToolComponent, IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-orbitax-connect-tile-viewer',
  standalone: false,
  templateUrl: './orbitax-connect-tile-viewer.component.html',
  styleUrl: './orbitax-connect-tile-viewer.component.scss'
})
export class OrbitaxConnectTileViewerComponent implements OnInit, IPlatformToolComponent {
  data: any;
  cards: DialogCard[] = [];
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel
  invalidateSubject: InvalidateSubject;
  selectedTab: TabModel;


  constructor(private commandService: CommandService, private fuseSplashScreenService: FuseSplashScreenService,private router: Router) {


  }

  ngOnInit(): void {

    console.log(this.data);
    console.log(this.selectedTab);
    console.log(this.magicLinkModel);
    const list = this.data?.input?.PlatformDialog?.additionalCommands?.PlatformDialogTileList ?? Object.values(this.magicLinkModel?.additionalCommands);


    if (Array.isArray(list) && list.length > 0) {

      const newCards: DialogCard[] = list.map(item => ({
        icon: item.fieldValues.icon,
        title: item.fieldValues.tiletitle,
        description: item.fieldValues.description,
        buttonText: item.fieldValues.buttonText,
        command: item
      }));

      this.cards.push(...newCards);
    }

  }


  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }

  //   cards: DialogCard[] = [
  //   {
  //     icon: 'fa-solid fa-layer-group',
  //     title: 'Partner Connection',
  //     description: 'Select from existing certified connections to Orbitax Partners, such as ONESOURCE Tax Provision and Longview Tax Provision.',
  //     buttonText: 'Partner Connection',
  //     buttonAction: () => this.onPartnerConnection()
  //   },
  //   {
  //     icon: 'fa-solid fa-layer-group',
  //     title: 'Default Connection',
  //     description: 'Select from over 90 out-of-the-box connections via API, including SFTP, ERP Systems, Data Lakes and Tax Solutions.',
  //     buttonText: 'Default Connection',
  //     buttonAction: () => this.onDefaultConnection()
  //   },
  //   {
  //     icon: 'fa-solid fa-layer-group',
  //     title: 'Custom Connection',
  //     description: 'Contact Orbitax to configure a connection to a custom 3rd-party system that is not currently available via the other options.',
  //     buttonText: 'Contact Orbitax',
  //     buttonAction: () => this.onContactOrbitax()
  //   },
  // ];



  // onPartnerConnection() {
  //   console.log('Partner Connection clicked');
  // }

  // onDefaultConnection() {
  //   console.log('Default Connection clicked');
  // }

  // onContactOrbitax() {
  //   console.log('Contact Orbitax clicked');
  // }

  onButtonClick(command: any) {
    if(command.fieldValues['OpenNewWindowWithUrl']) {
      window.open(command.fieldValues['OpenNewWindowWithUrl'], '_blank');
      return;
    }

    var platformCommand = new PlatformCommand(command.name, command.api);
    for (const [key, value] of Object.entries(command.fieldValues)) {
      platformCommand.fieldValues[key] = value;
    }

    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(commandResponse => {
      this.fuseSplashScreenService.hide();

      if (commandResponse.fieldValues["RedirectUrl"]) {
        this.router.navigateByUrl(commandResponse.fieldValues["RedirectUrl"]);
        this.invalidateSubject.invalidate();
      }

    },
      error => {
        console.log(error);
        this.fuseSplashScreenService.hide();
      });
  }

}

interface DialogCard {
  icon: string;
  title: string;
  description: string;
  buttonText: string;
  command: any
}

